export default "__VITE_ASSET__8O86cT5j__"